module.exports = __webpack_public_path__ + "static/media/thumbnail_joe.b7bffe8b.jpg";